/**
 * Created by guga on 8/4/2016.
 */

import { Injectable } from '@angular/core';
import { RequestOptions, Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { AuthHttpSas }                    from './auth-http.sas';
import { ErrorHandlerBuilderSas }         from './error-handler-builder.sas';
import { IHttpHandler }                   from "../sas-models/http-handler";
import { IRequestPayload, RequestMethod } from "../sas-models/request-payload";
import { IRequestErrorHandler }           from '../sas-models/error-handler';

/***********************************************
 * Author : Gustavo(gmm)
 * Date   : 04/08/2016
 *
 * This service is a wrapper for AuthService. It hides common code like map and catch from observables. It also provide an IRequestPayload for errorHandlers.
 *
 * All request methods(get, post, postJson, put, putJson and delete) use ErrorHandlerService as error handler. If you want to use error handlers separate from ErrorHandlerService
 * see request method.
 *
 * This is the preferred service to do authenticated requests(using tokens). If you want to use pure authenticated requests without IRequestPayload or without common observables operators
 * then use AuthService directly instead.
 *
 * This service also provides retry and request methods. Use these methods if you want to write custom error handlers / custom services that implement custom different
 * error handler for each request.
 *
 * This service fulfill IRequestPayload as follows :
 *   url     : original url (string)
 *   options : original options (RequestOptions)
 *   body    : original body (null if body was not provided, string or any if provided)
 *   method  : method used (get, post, postJson, put, putJson, delete)
 *
 * If you use ErrorHandlerService to implement a custom error handler, you will want to take advantages of IRequestPayload to gather information about the request
 *
 ***********************************************/

@Injectable()
export class AuthHttpWrapperSas implements IHttpHandler {
    public constructor(private _authHttp : AuthHttpSas, private _ehb : ErrorHandlerBuilderSas) {}

    private _request(requestPayload : IRequestPayload, errorHandler : IRequestErrorHandler) : Observable<any> {
        switch (requestPayload.method) {
            case RequestMethod.get :
                return this._authHttp.get(requestPayload.url, requestPayload.options)
                    .map( (res : Response) => res.json() )
                    .catch( this._ehb.buildRequestErrorHandler(errorHandler, requestPayload) );
            case RequestMethod.post :
                return this._authHttp.post(requestPayload.url, requestPayload.body, requestPayload.options)
                    .map( (res : Response) => res.json() )
                    .catch( this._ehb.buildRequestErrorHandler(errorHandler, requestPayload) );
            case RequestMethod.postJson :
                return this._authHttp.postJson(requestPayload.url, requestPayload.body, requestPayload.options)
                    .map( (res : Response) => res.json() )
                    .catch( this._ehb.buildRequestErrorHandler(errorHandler, requestPayload) );
            case RequestMethod.put :
                return this._authHttp.put(requestPayload.url, requestPayload.body, requestPayload.options)
                    .map( (res : Response) => res.json() )
                    .catch( this._ehb.buildRequestErrorHandler(errorHandler, requestPayload) );
            case RequestMethod.putJson :
                return this._authHttp.putJson(requestPayload.url, requestPayload.body, requestPayload.options)
                    .map( (res : Response) => res.json() )
                    .catch( this._ehb.buildRequestErrorHandler(errorHandler, requestPayload) );
            case RequestMethod.delete :
                return this._authHttp.delete(requestPayload.url, requestPayload.options)
                    .map( (res : Response) => res.json() )
                    .catch( this._ehb.buildRequestErrorHandler(errorHandler, requestPayload) );
            default :
                return Observable.throw('Undefined method');
        }
    }

    public get(url: string, options ?: RequestOptions, requestErrorHandler ?: IRequestErrorHandler): Observable<any> {
        let requestPayload : IRequestPayload = {url, options, method : RequestMethod.get};

        return this._authHttp.get(url, options)
            .map( (res : Response) => res.json() )
            .catch( this._ehb.buildRequestErrorHandler(requestErrorHandler, requestPayload) );
    }

    public post(url: string, body : any, options ?: RequestOptions, requestErrorHandler ?: IRequestErrorHandler): Observable<any> {
        let requestPayload : IRequestPayload = {url, options, method : RequestMethod.post, body};

        return this._authHttp.post(url, body, options)
            .map( (res : Response) => res.json() )
            .catch( this._ehb.buildRequestErrorHandler(requestErrorHandler, requestPayload) );
    }

    public postJson(url: string, body: string, options ?: RequestOptions, requestErrorHandler ?: IRequestErrorHandler): Observable<any> {
        let requestPayload : IRequestPayload = {url, options, method : RequestMethod.postJson, body};

        return this._authHttp.postJson(url, body, options)
            .map( (res : Response) => res.json() )
            .catch( this._ehb.buildRequestErrorHandler(requestErrorHandler, requestPayload) );
    }

    public put(url: string, body: any, options ?: RequestOptions, requestErrorHandler ?: IRequestErrorHandler): Observable<any> {
        let requestPayload : IRequestPayload = {url, options, method : RequestMethod.put, body};

        return this._authHttp.put(url, body, options)
            .map( (res : Response) => res.json() )
            .catch( this._ehb.buildRequestErrorHandler(requestErrorHandler, requestPayload) );
    }

    public putJson(url: string, body: string, options ?: RequestOptions, requestErrorHandler ?: IRequestErrorHandler): Observable<any> {
        let requestPayload : IRequestPayload = {url, options, method : RequestMethod.putJson, body};

        return this._authHttp.putJson(url, body, options)
            .map( (res : Response) => res.json() )
            .catch( this._ehb.buildRequestErrorHandler(requestErrorHandler, requestPayload) );
    }

    public delete(url: string, options ?: RequestOptions, requestErrorHandler ?: IRequestErrorHandler): Observable<any> {
        let requestPayload : IRequestPayload = {url, options, method : RequestMethod.delete};

        return this._authHttp.delete(url, options)
            .map( (res : Response) => res.json() )
            .catch( this._ehb.buildRequestErrorHandler(requestErrorHandler, requestPayload) );
    }

    public request(requestPayload : IRequestPayload, errorHandler ?: IRequestErrorHandler) : Observable<any> {
        return this._request(requestPayload, errorHandler);
    }
}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/sas/auth-http-wrapper.sas.ts